export enum FORM_TYPE {
  ADD,
  EDIT,
  VIEW,
}
